const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Amazon S3 Uploads Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('S3Uploads', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
    return $resource(appConfiguration.apiUrl + '/v3/s3-uploads/:resource/:subresource', null, {
      imagePolicy: {params: {resource: 'image-policy', subresource: ''}, method: 'GET', isArray: false},
      filePolicy: {params: {resource: 'file-policy', subresource: ''}, method: 'GET', isArray: false},
      videoPolicy: {params: {resource: 'video-policy', subresource: ''}, method: 'GET', isArray: false}
    });
  }]);
